import React from 'react';
import { PageHeader } from '@ant-design/pro-layout';
import Inventory from 'components/inventory';

const MaterialsInventory = () => (
  <React.Fragment>
    <PageHeader
      title="Инвентарь"
      style={{ paddingLeft: 0, paddingRight: 0, paddingTop: 0 }}
    />
    <Inventory />
  </React.Fragment>
);

export default MaterialsInventory;
